import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainPage from './Components/Layouts/MainPage/MainPage';
import ChatMessage from './Components/Pages/Chats/ChatMessage';
import PrivateRoute from './PrivateRoute/PrivateRoute';
import UnAuthorizedPage from './Components/Pages/UnAuthorized/UnAuthorizedPage';
import AuthorizedPage from './Components/Pages/AuthorizedPage/AuthorizedPage';
import AuthorizedPrivateRoute from './PrivateRoute/AuthorizedPrivateRoute/AuthorizedPrivateRoute';
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="" element={<PrivateRoute />}>
            <Route path="/" element={<MainPage />}>
              <Route path="/" element={<ChatMessage />} />
              {/* <Route path="/message/:id" element={<ChatMessage />} /> */}
            </Route>
          </Route>

          {/* <Route path="" element={<AuthorizedPrivateRoute />}> */}
            <Route path="/authorized/:id" element={<AuthorizedPage />} />
            <Route path="/unauthorized" element={<UnAuthorizedPage />} />
          {/* </Route> */}
        </Routes>

      </BrowserRouter>


    </>
  );
}

export default App;
